/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-16 11:16:17
 **/

export type GroupStates = {
	groups: WebServices.People.List.Data;
};

export type GroupDispatch = {
	set_groups(groups: WebServices.People.List.Data): void;
};

export const InitialGroupStates: GroupStates = {
	groups: []
};
